module.exports = __webpack_public_path__ + "img/support.2e366861.svg";